import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Reads brand_name + favicon_url from /api/landing/public and applies them
 * to <title> and the <link rel="icon"> + <link rel="apple-touch-icon"> tags.
 *
 * Mounted once at the App root so EVERY page (landing, login, dashboard, admin)
 * picks up the same branded favicon + title.
 */
export default function BrandHead() {
  useEffect(() => {
    let cancelled = false;
    const apply = (settings) => {
      if (cancelled || !settings) return;
      // Title
      const brand = settings.brand_name;
      if (brand) document.title = brand;
      // Favicon
      const url = settings.favicon_url || settings.logo_url;
      if (!url) return;
      const setHref = (id) => {
        const el = document.getElementById(id);
        if (el) el.href = url;
      };
      setHref("dynamic-favicon");
      setHref("dynamic-apple-icon");
    };
    // Try cache first to avoid the flash, then revalidate from server
    try {
      const cached = localStorage.getItem("botito_brand");
      if (cached) apply(JSON.parse(cached));
    } catch (e) { /* ignore */ }
    axios
      .get(`${API}/landing/public`)
      .then(({ data }) => {
        const minimal = {
          brand_name: data.settings?.brand_name,
          favicon_url: data.settings?.favicon_url,
          logo_url: data.settings?.logo_url,
        };
        try { localStorage.setItem("botito_brand", JSON.stringify(minimal)); } catch (e) { /* ignore */ }
        apply(minimal);
      })
      .catch(() => { /* fail silent — tab keeps default title */ });
    return () => { cancelled = true; };
  }, []);

  return null;
}
